/* eslint-disable no-param-reassign */
import { CalibrationPerformanceMetricsReverseParser } from '../../../types';

const reverseParser: CalibrationPerformanceMetricsReverseParser = params => {
  const {
    cells,
    tableData: { calibration },
  } = params;
  // all cells from the same row have the relevant attributes to search so we can filter by y = 1 arbitrarily
  const allCellObjects = Object.values(cells).filter(cell => Number(cell.y) === 1);
  (calibration.performances ?? []).forEach(performance => {
    const performanceCells = allCellObjects.filter(
      cell => cell.rowHeaderId === performance.cap_iq_id || cell.rowHeaderName === performance.name
    );
    if (performanceCells.length) {
      performance.enabled = performanceCells[0].enabled ?? true;
      performance.cap_iq_id = performanceCells[0].rowHeaderId ?? '';
    }
  });
};

export default reverseParser;
